import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";

const imagePng = "https://res.cloudinary.com/dqwlxo5fe/image/upload/v1670971421/nilebooking/hero-right_r12wdk.png";
export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10 pb-14 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-medium text-4xl md:text-5xl xl:text-7xl !leading-[114%] ">
            Find your perfect place to stay with Nilebooking
          </h2>
          <span className="text-base md:text-lg text-neutral-500 dark:text-neutral-400">
          Take the hassle out of booking your next hotel room or apartment with Nilebooking – 
          an easy-to-use application that lets you search for and book the place of your dreams
          </span>
          {/*<ButtonPrimary>Start your search</ButtonPrimary>*/}
        </div>
        <div className="flex-grow">
          <img className="w-full" src={imagePng} alt="hero" />
        </div>
      </div>

      <div className="hidden lg:block z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <HeroSearchForm  text="Start your search"/>
      </div>
    </div>
  );
};

export default SectionHero;
